import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import AdvisoryCityViewModel from '../../../../core/features/setting/viewmodels/AdvisoryCityViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'Settings-AdvisoryCities',
            parentFilter: '',
            parents: [],
            viewModel: null,
            permissions: null,
            modules: [],
            rules: {
                code: [
                    { required: true, message: 'Código requerido.', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: 'Nombre requerido.', trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true,
        },
        formData: {
            type: Object,
            required: true,
        },
    },
    created() {
        this.viewModel = new AdvisoryCityViewModel(this)
    },
    mounted() { },
    methods: {
        onActive(response) {

        },
        onSearchCourseCategory(data) {
            if (data) {
                this.viewModel.findCourseCategories(`Name=${data}`)
            } else {
                this.parents = []
            }
        },
        onSearchCourseCategoriesResponse(response) {
            this.parents = response;
          },
          onFocusCourseCategory() {
            this.$forceUpdate()
        },
        onSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.onSave(this.formData)
                }
            });
        },
        onCanSaveOrUpdate() {
            return this.canCreate(this.modulePermissions) || this.canUpdate(this.modulePermissions)
        },
        onSaveResponse(response) {
            this.showLoading(false, '');
            this.onShowSuccess(response.message);
            this.showComponent(false);
            EventBus.$emit('onSubmitedAdvisoryCity', null);
        }
    }
}